import { CALL_API } from '../../../common/middleware/api';

export const OPERATIONS_ANALYTICS_REQUEST = 'OPERATIONS_ANALYTICS_REQUEST';
export const OPERATIONS_ANALYTICS_SUCCESS = 'OPERATIONS_ANALYTICS_SUCCESS';
export const OPERATIONS_ANALYTICS_FAILURE = 'OPERATIONS_ANALYTICS_FAILURE';

export const loadOperationsAnalyticsData = (item, options) => ({
	[CALL_API]: {
		types: [OPERATIONS_ANALYTICS_REQUEST, OPERATIONS_ANALYTICS_SUCCESS, OPERATIONS_ANALYTICS_FAILURE],
		endpoint: `api/analytics/operations/${item}`,
		method: 'POST',
		request: options
	},
	item
});